import store from "../../../redux/store";
import actionTypes from "./actionTypes";
import {disableProdSwitcher} from "../../../redux/prodswitcher/prodSwitcherActions";
import {keycloak} from "../../../keycloak-config";

export async function logout() {
    clearAuthentication();
    await keycloak.logout();
}

export function clearAuthentication() {
    store.dispatch({
        type: actionTypes.CLEAR_AUTHENTICATION
    });
    disableProdSwitcher();
}

export function setAuthDetails(payload) {
    store.dispatch({
        type: actionTypes.SET_AUTH_DETAILS,
        payload
    })
}

export function setAuthSuccess() {
    store.dispatch({
        type: actionTypes.SET_AUTH_SUCCESS
    })
}
